// eslint-disable-next-line no-shadow
export enum OrderTabEnum {
  order = 'tab-order',
  unpublished = 'tab-unpublished',
  harvestingOrders = 'tab-harvestingOrders'
}
